"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const function_1 = require("fp-ts/lib/function");
const Either_1 = require("fp-ts/lib/Either");
const t = require("io-ts");
const domain_1 = require("../euro/domain");
class EuroCentsType extends t.Type {
    constructor() {
        super('EuroCents', (u) => u instanceof domain_1.EuroCents, (u, c) => this.is(u) ? t.success(u) : t.failure(u, c), function_1.identity);
        this._tag = 'EuroCentsType';
    }
}
const euroCents = new EuroCentsType();
exports.euroCentsFromNumber = new t.Type('EuroCentsFromNumber', euroCents.is, (u, c) => Either_1.either.chain(t.Int.validate(u, c), i => t.success(new domain_1.EuroCents(i))), x => x.cents);
